/* Simple Sip — ss-port.js: the real buy path the static mock faked. ss.js stays the mock's script. */
(function () {
  var d = document;
  function S() { return window.MinimogSettings || {}; }
  function fmt(cents, f) {
    f = f || '${{amount}}';
    var v = cents / 100;
    function n(x, dec, th, ds) { var s = x.toFixed(dec).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s[0] + (s[1] ? ds + s[1] : ''); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return n(v, 0, ',', '.');
        case 'amount_with_comma_separator': return n(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return n(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return n(v, 2, "'", '.');
        default: return n(v, 2, ',', '.');
      }
    });
  }
  /* several lines in one request, the way Minimog's own bundle section does it: re-render its cart sections, open the drawer */
  function addItems(items, btn, msg) {
    var sections = [];
    d.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    var s = S(), url = (s.routes && s.routes.cart_add_url) || '/cart/add';
    btn.classList.add('is-loading');
    if (msg) { msg.hidden = true; msg.textContent = ''; }
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { if (msg) { msg.textContent = res.description || res.message || 'This item could not be added to your bag.'; msg.hidden = false; } return; }
        var cd = d.querySelector('m-cart-drawer');
        if (s.use_ajax_atc !== false && cd && s.enable_cart_drawer !== false) {
          if (window.MinimogEvents && window.MinimogTheme) window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: res });
          cd.open && cd.open();
        } else { window.location = (s.routes && s.routes.cart) || '/cart'; }
      })
      .catch(function () { if (msg) { msg.textContent = 'This item could not be added to your bag. Please try again.'; msg.hidden = false; } })
      .then(function () { btn.classList.remove('is-loading'); });
  }

  function pdp(root) {
    if (root.dataset.ssInit) return; root.dataset.ssInit = '1';
    var money = root.getAttribute('data-money');
    var btn = root.querySelector('[data-ss-atc]');
    var qIn = root.querySelector('[data-ss-qty] input');
    var msg = root.querySelector('.ss-pdp__msg');
    function qty() { var q = parseInt(qIn && qIn.value, 10); return q > 0 ? Math.min(q, 20) : 1; }
    function total() {
      if (!btn) return;
      var t = (+btn.dataset.price || 0) * qty();
      root.querySelectorAll('[data-ss-addons] input:checked').forEach(function (a) { t += +a.dataset.price || 0; });
      root.querySelectorAll('[data-ss-total]').forEach(function (e) { e.textContent = fmt(t, money); });
    }
    var qBox = root.querySelector('[data-ss-qty]');
    if (qBox) {
      qBox.addEventListener('click', function (e) { var b = e.target.closest('button[data-q]'); if (!b) return; qIn.value = Math.max(1, Math.min(20, qty() + +b.dataset.q)); total(); });
      qIn.addEventListener('input', total); qIn.addEventListener('change', function () { qIn.value = qty(); total(); });
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-ss-addons]')) total();
      var sel = e.target.closest('[data-ss-variant]');
      if (sel && btn) {
        var o = sel.options[sel.selectedIndex];
        btn.dataset.variant = sel.value; btn.dataset.price = o.getAttribute('data-price');
        var p = fmt(+btn.dataset.price, money);
        root.querySelectorAll('[data-ss-now],[data-ss-sticky-price]').forEach(function (x) { x.textContent = p; });
        total();
      }
    });
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault(); if (btn.disabled) return;
      var pk = root.getAttribute('data-pre-key'), pv = root.getAttribute('data-pre-val'), props = null;
      if (pk && pv) { props = {}; props[pk] = pv; }
      function line(id, q) { var o = { id: +id, quantity: q }; if (props) o.properties = props; return o; }
      var items = [line(btn.dataset.variant, qty())];
      root.querySelectorAll('[data-ss-addons] input:checked').forEach(function (a) { items.push(line(a.value, 1)); });
      addItems(items, btn, msg);
    });

    /* gallery: thumbs drive the native snap track; the track drives the active thumb */
    var track = root.querySelector('.ss-pdp__track'), thumbs = root.querySelectorAll('[data-ss-thumb]'), row = root.querySelector('.ss-pdp__thumbs');
    if (track && thumbs.length) {
      var slides = track.children;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var s = slides[+t.dataset.ssThumb]; if (!s) return;
          track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
          var a = thumbs[i];
          if (a && row) { var l = a.offsetLeft - row.offsetLeft, r = l + a.offsetWidth; if (l < row.scrollLeft || r > row.scrollLeft + row.clientWidth) row.scrollTo({ left: l - 12, behavior: 'smooth' }); }
        });
      }, { passive: true });
    }

    /* sticky buy bar: only once the main button has scrolled away above the viewport */
    var bar = root.querySelector('[data-ss-sticky]');
    if (bar && btn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          var on = !x.isIntersecting && x.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          var b = bar.querySelector('[data-ss-sticky-btn]'); if (b) b.tabIndex = on ? 0 : -1;
        });
      });
      io.observe(btn);
      var sb = bar.querySelector('[data-ss-sticky-btn]');
      if (sb) sb.addEventListener('click', function () { btn.click(); });
    }
    total();
  }

  function init() { d.querySelectorAll('[data-ss-pdp]').forEach(pdp); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();
